<template>
  <ts-exhibition-page :data-list="dataObj.list" />
</template>

<script>
import { Component, Prop, Vue } from 'vue-property-decorator'
import TsExhibitionPage from '@/components/TsExhibition/index'

@Component({
  name: 'ActivationMsg',
  components: {
    TsExhibitionPage
  }
})
export default class extends Vue {
  @Prop({ default: Object }) dataObj;
}
</script>

<style scoped>

</style>
